import { Pipe, PipeTransform } from '@angular/core';
import * as moment from "moment";
@Pipe({
  name: 'dateFormat'
})
export class DateFormatPipe implements PipeTransform {

  transform(date: any, format?: any): any {
    return moment(date).format(format);
  }

}



// WEBPACK FOOTER //
// ./src/app/pipes/date-format.pipe.ts